import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { MainLayout } from './components/layout/MainLayout';
import LoginPage from './pages/LoginPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import GroupsPage from './pages/GroupsPage';
import CreateChallengePage from './pages/CreateChallengePage';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import EventViewPage from './pages/EventViewPage';
import MatchesPage from './pages/MatchesPage';
import PaymentsPage from './pages/PaymentsPage';
import InvoicesPage from './pages/InvoicesPage';
import TicketsPage from './pages/TicketsPage';
import EmployeesPage from './pages/EmployeesPage';
import EmployeeFormPage from './pages/EmployeeFormPage';
import PasswordRequestsPage from './pages/PasswordRequestsPage';
import TasksPage from './pages/TasksPage';
import TimesheetsPage from './pages/TimesheetsPage';
import CustomerSupportPage from './pages/CustomerSupportPage';
import MonthlyAttendancePage from './pages/MonthlyAttendancePage';
import SalaryCalculationPage from './pages/SalaryCalculationPage';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          <Route element={<MainLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/employees" element={<EmployeesPage />} />
            <Route path="/employees/new" element={<EmployeeFormPage />} />
            <Route path="/employees/:id/edit" element={<EmployeeFormPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/timesheets" element={<TimesheetsPage />} />
            <Route path="/monthly-attendance" element={<MonthlyAttendancePage />} />
            <Route path="/salary-calculation" element={<SalaryCalculationPage />} />
            <Route path="/password-requests" element={<PasswordRequestsPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/groups" element={<GroupsPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/create" element={<CreateChallengePage />} />
            <Route path="/events/:id/view" element={<EventViewPage />} />
            <Route path="/events/:id" element={<EventDetailPage />} />
            <Route path="/matches" element={<MatchesPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/invoices" element={<InvoicesPage />} />
            <Route path="/tickets" element={<TicketsPage />} />
            <Route path="/customer-support" element={<CustomerSupportPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
